import type { AttributeType, AttributeTypeListResponse } from '@/api/models';

/**
 * The attribute-type reads pass the wire through, with one addition: every
 * type comes back with `variationCategories`, `[]` when the server omits it,
 * so a reader (the catalog-import template) can rely on the list being
 * there. Nothing else is touched.
 */
export const toAttributeType = (wire: AttributeType): AttributeType => ({
    ...wire,
    variationCategories: wire.variationCategories ?? [],
});

export const toAttributeTypeList = (
    wire: AttributeTypeListResponse,
): AttributeTypeListResponse => ({
    ...wire,
    items: (wire.items ?? []).map(toAttributeType),
});
